<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <loading :active.sync="loadingFull" :can-cancel="false" :is-full-page="true"></loading>

    <b-card class="bCardGlobalXL">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="10">
          <div>
            <p class="textoSubtitulo">Catálogo de tratamientos</p>
          </div>
        </b-col>
        <b-col cols="6" md="2">
          <div>
            <p style="text-align: end" class="textoSubtitulo">Tx_sku</p>
          </div>
        </b-col>
      </b-row>

      <div class="tabs">
        <nav class="tabs-nav">
          <ul>
            <li
              :class="{ active: activeTab === index }"
              v-for="(tab, index) in tabs"
              :key="index"
            >
              <a @click="changeTab(index, tab)" :href="`#tabs-panel-${index + 1}`">{{
                tab.descripcion
              }}</a>
            </li>
          </ul>
        </nav>
      </div>


      
      <div class="mt-4" > <!--v-if="activeTab === 0"-->

        <b-popover target="popover-filtro-tipopaciente" triggers="click blur" placement="rigth">
          <div class="d-flex align-items-center">
            <td><em class="engrane_naranja_svg sm"></em></td>
            <td><p class="mt-2 mb-2" style="font-size: .80em">Tratamiento padre con algún tratamiento hijo sin configuración</p></td>
          </div>
          <div class="d-flex align-items-center">
            <td><b-icon icon="circle-fill" aria-hidden="true" font-scale="1" style="color: #FFDBC7;"></b-icon></td>
            <td><p class="mt-2 mb-2" style="font-size: .80em">Tratamientos sin configurar en catalogo SKU</p></td>
          </div>
        </b-popover>

        <b-row>
          <b-col sm="12" md="12" lg="6" xl="6">
            <b-row>
              <b-col sm="12" md="12" lg="5" xl="5">
                <p class="text-left" style="font-weight: 600; color: #0069A9">{{this.nombreTabSeleccionado}} de nivel 1</p>
              </b-col>
              <b-col sm="12" md="12" lg="1" xl="1">
                  <em class="info_trt_svg" id="popover-filtro-tipopaciente"
                      style=" position: absolute; top: -4px; left: 100px; width: 38px; cursor: pointer"></em>
              </b-col>
            </b-row>
          </b-col>
        </b-row>


        <div class="row">
          <div class="col-4" style="">
            <div style="padding-left: 4%; padding-right: 4%; border: 1px solid #EBEBEB; min-height: 70vh; border-radius: 15px;">
              <div class="row" style=" width: 105%;">
                <div class="col-10" style="padding-left: 0px; padding-right: 0px;">
                  <div class="barras d-flex " style="margin-top: 10px;"
                       :style="catalogoTratamientos != undefined && catalogoTratamientos != null ? 'margin-left:0px; margin-right:0px;':''">
                    <b-form-input v-if="$localStorageService.can('Tx_sku_Busqueda')" class="input-filter" v-model="palabraClaveBusqueda" placeholder="Búsqueda por nombre del tratamiento" type="text"
                                  @keydown.enter.prevent="buscarTratamiento()">
                    </b-form-input>
                      <b-button class="btn-extra-small" variant="info" @click="buscarTratamiento()">
                        <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px;"></em></span>
                        <!-- <span v-else><b-spinner small></b-spinner></span> -->
                      </b-button>
                  </div>
                </div>
                <div class="col-2" style="min-width: 1vh; margin-right: 0px; padding-right: 0px;">
                  <b-button v-if="$localStorageService.can('Tx_sku_agregarTx')" v-b-tooltip.hover.v-light.topright
                            @click="agregarNuevoTratamiento()" variant="light"
                            class="mt-2 button-circle shadow-botones text-dentalia"
                            :title="'Agregar nuevo '+ nombreTabSeleccionado + ' nivel 1'"
                            :disabled="resultadosBusquedaFiltro.filter(id => id.idTratamientoNuevo == null).length > 0"
                  >
                    <em class="mas_azul_svg" ></em>
                  </b-button>
                </div>
              </div>

              <div class="mt-3" style=" border-bottom: 1px solid #E5E5E5;">
                <p class="text-left" style="font-size: .8vw; font-weight: 600;">Nombre {{ this.nombreTabSeleccionado }}</p>
              </div>
              <div class="d-flex justify-content-center align-items-center" style="min-height: 50vh;" v-if="catalogoTratamientos.length == 0">
                <p  style="font-size: .85vw;">No se encontraron tratamientos</p>
              </div>
              <div v-else style="height: 600px; overflow: scroll">
                <div style="width: 100%;">
                  <SelectTratamientos v-bind:catalogoTratamientos="resultadosBusquedaFiltro" />
                </div>
              </div>
              
            </div>
          </div>
          <div class="col-8" style="padding-left: 0px; padding-right: 0px;">
            <div v-if="catalogoTratamientos.length == 0 || tratamientoSeleccionado == null"
                 class="d-flex justify-content-center align-items-center" style="min-height: 45vh;">
              <p style="font-size: .8vw;">Selecciona un tratamiento para comenzar</p>
            </div>
            
            <div v-else >
              <b-row>
                <b-col class="mt-10"  sm="8" md="8" lg="8" xl="8">
                  <p v-if="tratamientoSeleccionado.nombre != null && tratamientoSeleccionado.nombre != ''"
                     class="text-left" style="font-weight: 600; color: #17A2B8;">Tratamiento "{{tratamientoSeleccionado.nombre}}"</p>
                  <p v-else class="text-left" style="font-weight: 600; color: #17A2B8;">Tratamiento "Nuevo tratamiento"</p>
                  <h1 v-if="tratamientoSeleccionado.idTratamientoPadre !== null && tratamientoSeleccionado.completo === false"
                        class="text-left" style="color: #eaae8d; font-size: 11px"
                  > Este tratamiento aún no tiene configuración de sku, por favor de click en "configurar sku" para ir a la configuración </h1>
                </b-col>
                <b-col class="text-right"  sm="3" md="3" lg="3" xl="3">
                  <b-button variant="outline-primary" pill v-if="$localStorageService.can('Tx_sku_Bt_confsku')">
                    <router-link :to="{name: 'tratamiento', params: { id: tratamientoSeleccionado.idTratamiento },}">
<!--                      <em class="editar_svg_amarillo icon-boton"></em>-->
                      Configurar sku
                    </router-link>
                  </b-button>
                </b-col>
                <b-col   sm="1" md="1" lg="1" xl="1" v-if="tratamientoSeleccionado.subTratamientos !== null && tratamientoSeleccionado.subTratamientos.length === 0 ">
                  <em v-if="tratamientoSeleccionado.registroActivo && tratamientoSeleccionado.idTratamientoNuevo !== null && $localStorageService.can('Tx_sku_eliminar')"
                      class="trash_svg" style="cursor: pointer; width: 30px"
                      @click="eliminarTratamiento(tratamientoSeleccionado, false)"
                      v-b-tooltip.hover.left.top.v-light
                      title="Inactivar tratamiento"
                  ></em>
                  <em v-else-if="tratamientoSeleccionado.idTratamientoNuevo !== null && !tratamientoSeleccionado.registroActivo"
                      class="diente_verde_svg"
                      style="cursor: pointer; width: 30px"
                      @click="eliminarTratamiento(tratamientoSeleccionado, true)"
                      v-b-tooltip.hover.left.top.v-light
                      title="Activar tratamiento"
                  ></em>
                </b-col>
              </b-row>



              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(() => guardarTratamiento())">
                <div class="mt-4" id="formularioTratamiento" v-if="tratamientoSeleccionado != null "
                     style="height: 500px; overflow: scroll"> <!--style="height: 400px"-->
                  <b-row>
                    <b-col class="d-flex" sm="12" md="12" lg="6" xl="6" style="font-size: 14px">
                      <p class="mr-3">Última modificación:</p>
                      <p> {{tratamientoSeleccionado.fechaModificacion | formatoFechaTexto}}</p>
                    </b-col>
                    <b-col class=" d-flex"  sm="12" md="12" lg="6" xl="6" style="font-size: 14px">
                      <p class="mr-3">Usuario modificación:</p>
                      <p>{{tratamientoSeleccionado.usuarioModificacion }}</p>
                    </b-col>
                    <b-col class="mt-4"  sm="6" md="6" lg="2" xl="2">
                      <b-form-group class="text-left">
                        <label for="sku"
                        > ID SKU
                          <validacion/>
                        </label>
                        <b-form-input
                            id="sku" name="sku"
                            placeholder="Ingresa el sku"
                            v-model="tratamientoSeleccionado.sku"
                            required
                            type="text"
                            @keypress="onlyNumber($event)"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col class=" mt-4"  sm="12" md="12" lg="5" xl="5">
                      <b-form-group class="text-left">
                        <label for="nombreTratamiento"
                        > Nombre
                          <validacion/>
                        </label>
                        <b-form-input
                          id="nombreTratamiento" name="nombreTratamiento"
                          placeholder="Ingresa el nombre del tratamiento"
                          v-model="tratamientoSeleccionado.nombre"
                          required
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col class=" mt-4"  sm="12" md="12" lg="5" xl="5">
                      <b-form-group class="text-left">
                        <label for="descripcionTratamiento"
                        >Descripción
                          <validacion/>
                        </label>
                        <b-form-input
                          id="descripcionTratamiento" name="descripcionTratamiento"
                          placeholder="Ingresa la descripción del tratamiento"
                          v-model="tratamientoSeleccionado.descripcion"
                          required
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col class="mt-4"  sm="12" md="6" lg="4" xl="4">
                      <b-form-group class="text-left">
                        <label for="extensionTratamiento"
                        >Extensión
                          <validacion/>
                        </label>
                        <v-select
                          id="extensionTratamiento" name="extensionTratamiento"
                          placeholder="Selecciona la extensión del tratamiento"
                          :options="listaExtension"
                          v-model="tratamientoSeleccionado.idExtensionTratamiento"
                          label="extensionTratamiento"
                          :reduce="(variable) => variable.idExtensionTratamiento"
                          required
                        >
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col class="mt-4"  sm="12" md="6" lg="4" xl="4">
                      <b-form-group class="text-left">
                        <label for="valorTratamiento"
                        >Valor
                          <validacion/>
                        </label>
                        <v-select
                          id="valorTratamiento" name="valorTratamiento"
                          placeholder="Selecciona el valor del tratamiento"
                          :options="listaValor"
                          v-model="tratamientoSeleccionado.idValorTratamiento"
                          label="valorTratamiento"
                          :reduce="(variable) => variable.idValorTratamiento"
                          required
                        >
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col class="mt-4"  sm="12" md="6" lg="4" xl="4">
                      <b-form-group class="text-left">
                        <label for="especialidadTratamiento"
                        >Especialidad
                          <validacion/>
                        </label>
                        <v-select
                          id="especialidadTratamiento" name="especialidadTratamiento" 
                          placeholder="Selecciona la especialidad del tratamiento"
                          :options="listaEspecialidades"
                          v-model="tratamientoSeleccionado.idEspecialidad"
                          label="especialidad"
                          :reduce="(variable) => variable.id"
                          required
                        >
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col class="mt-4"  sm="12" md="6" lg="4" xl="4">
                      <b-form-group class="text-left">
                        <label for="especialidadTratamiento"
                        >¿Tiene subcatálogo?
                          <validacion/>
                        </label>
                        <b-form-checkbox
                          v-if="$localStorageService.can('Tx_sku_onoff')"
                          class="text-left"
                          v-model="tratamientoSeleccionado.subCatalogo"
                          name="check-button"
                          @change="iniciarLista(tratamientoSeleccionado)"
                          switch>
                      </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                    <template v-if="tratamientoSeleccionado.metadatos != null && typeof tratamientoSeleccionado.metadatos !== 'string'">
                      <b-col class="mt-4"  sm="12" md="6" lg="4" xl="4"
                             v-for="item of tratamientoSeleccionado.metadatos" :key="'caracteristica-'+item.idCaracteristica">
                        <b-form-group class="text-left">
                          <label > {{item.descripcionCaracteristica}} </label>
                          <b-form-input type="text"
                                        minlength="3"
                                        maxlength="100"
                                        v-model="item.caracteristicaIngresada"
                                        :placeholder="'Ingrese '+ item.descripcionCaracteristica"
                          />
                        </b-form-group>
                      </b-col>
                    </template>




                        <b-col class="text-left"  sm="12" md="12" lg="12" xl="12"
                              v-if="tratamientoSeleccionado.subCatalogo" :id="tratamientoSeleccionado.idTratamiento">
                          <hr>
                          <b-row>
                            <b-col sm="12" md="10" lg="10" xl="10">
                              <p class="ml-1 titulos-peques" >
                                Tratamientos de nivel 2
                              </p>
                            </b-col>
                            <b-col class="text-center" sm="12" md="2" lg="2" xl="2">
                              <b-button v-b-tooltip.hover.v-light.topright="'Agregar sub-tratamiento'"
                                        @click="agregarSubTratamiento(tratamientoSeleccionado)" variant="light"
                                        class="button-circle shadow-botones text-dentalia"
                                        v-if="$localStorageService.can('Tx_sku_agregar_subtx')">
                                <em class="mas_azul_svg" ></em>
                              </b-button>
                            </b-col>
                          </b-row>

                              <b-card class="contenedorTablaSinColor"
                                  style="margin-block: 10px;"
                                  v-for="(tx, index) in listaAdicional" :key="'txNuevo'+index">
                                <b-row>
                                  <b-col class="text-left"  sm="12" md="10" lg="10" xl="10">
                                    <p class="ml-1 titulos-peques"
                                       v-if=" tx.nombre === null || tx.nombre === ''"
                                       style="font-size: 12px; font-weight: normal"
                                       v-b-toggle="'subCat' + index"
                                    >
                                      Subcatálogo "Nuevo tratamiento" <!--<strong><i> => SKU: {{tratamientoSeleccionado.sku}}.{{tx.sku}} </i></strong>-->
                                    </p>
                                    <p class="ml-1 titulos-peques"
                                       v-else
                                       style="font-size: 12px; font-weight: normal"
                                       v-b-toggle="'subCat' + index"
                                    >
                                      Subcatálogo "{{tx.nombre}}"
                                      <strong><i>
                                        <b-icon style="color: #18d11b" icon="arrow-right-circle" animation="cylon" ></b-icon>
                                        SKU: {{tx.sku}}
                                      </i></strong>
                                    </p>
                                  </b-col>
                                  <b-col class="text-right"  sm="12" md="2" lg="2" xl="2">

                                      <b-icon :id="'subCat' + index" style="cursor: pointer"
                                              v-if="!showOptions" icon="chevron-down"
                                              v-b-toggle="'subCat' + index"
                                      ></b-icon>
                                      <b-icon :id="'subCat' + index" v-else
                                              style=" cursor: pointer"
                                              icon="chevron-up"
                                              v-b-toggle="'subCat' + index"
                                      ></b-icon>

                                  </b-col>
                                </b-row>


                                <b-collapse :id="'subCat' + index" visible accordion="my-accordion" role="tabpanel">
                                  <b-row>
                                    <b-col class="mt-2"  sm="6" md="6" lg="2" xl="2">
                                      <b-form-group class="text-left">
                                        <label for="sku"
                                        > ID SKU
                                          <validacion/>
                                        </label>
                                        <b-form-input
                                            name="sku"
                                            placeholder="Ingresa el sku"
                                            v-model="tx.sku"
                                            required
                                            type="text"
                                            @keypress="onlyNumber($event)"
                                        >
                                        </b-form-input>
                                      </b-form-group>
                                    </b-col>
                                    <b-col class="mt-2"  sm="12" md="12" lg="5" xl="5">
                                      <b-form-group class="text-left">
                                        <label for="nombreSubTratamiento"
                                        >nombre
                                          <validacion/>
                                        </label>
                                        <b-form-input
                                            id="nombreSubTratamiento" name="nombreSubTratamiento"
                                            placeholder="Ingresa el nombre del sub-tratamiento"
                                            v-model="tx.nombre"
                                            required
                                        >
                                        </b-form-input>
                                      </b-form-group>
                                    </b-col>
                                    <b-col class="mt-2"  sm="12" md="12" lg="5" xl="5">
                                      <b-form-group class="text-left">
                                        <label for="descripcionSubTratamiento"
                                        >Descripción
                                          <validacion/>
                                        </label>
                                        <b-form-input
                                            id="descripcionSubTratamiento" name="descripcionSubTratamiento"
                                            placeholder="Ingresa la descripción"
                                            v-model="tx.descripcion"
                                            required
                                        >
                                        </b-form-input>
                                      </b-form-group>
                                    </b-col>
                                    <template v-if="typeof tx.metadatos !== 'string'">
                                      <b-col class="mt-4"  sm="12" md="6" lg="4" xl="4"
                                             v-for="itm of tx.metadatos" :key="'caracteristica-'+itm.idCaracteristica">
                                        <b-form-group class="text-left">
                                          <label > {{itm.descripcionCaracteristica}} </label>
                                          <b-form-input type="text"
                                                        minlength="3"
                                                        maxlength="100"
                                                        v-model="itm.caracteristicaIngresada"
                                                        :placeholder="'Ingrese '+ itm.descripcionCaracteristica"
                                          />
                                        </b-form-group>
                                      </b-col>
                                    </template>

                                  </b-row>
                                </b-collapse>
                          </b-card>
                        </b-col>

                  </b-row>
                  <div class="d-flex justify-content-center mt-3" v-if="$localStorageService.can('Tx_sku_Guardar')">
                    <b-button class="mb-4 mr-5" size="sm" variant="primary" style="min-width: 100px;" v-if="loaderGuardar" disabled>
                      <b-spinner small></b-spinner>
                      Cargando...
                    </b-button>
                    <b-button v-else class="mb-4 mr-5" size="sm" variant="primary" type="submit" style="min-width: 100px;"
                      >Guardar
                    </b-button>
<!--                    #duda Que hace este boton de cancelar ************-->
<!--                    <b-button class="mb-4" size="sm" variant="outline-secondary" type="submit" style="min-width: 100px;">Cancelar</b-button>-->
                  </div>
                </div>
              </b-form>
              </validation-observer>

<!--              PERFILES Y CERTIFICACIONES ******************
              <div v-if="opcionTabSeleccionada === 1">
                <PerfilesCertificaciones
                    :listaPerfiles="listaPerfiles"
                />
              </div>-->
            </div>
          </div>
         

        </div>
      </div>
      <div v-if="activeTab === 1">

      </div>
    </b-card>
  </div>
</template>

<script>
import SelectTratamientos from "@/components/SelectTratamientos"
import Header from "@/components/Header";
import miniToastr from "mini-toastr";
/* import { required } from "vuelidate/lib/validators"; */

export default {
  name: "CatalogoTratamientos",
  components: { SelectTratamientos,  Header },

  data() {
    return {
      loadingFull: false,
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      activeTab: 0,
      showOptions: true,
      tabs: [{
        idCategoriaNuevo: null,
        descripcion: null
      }],
      nombreTabSeleccionado: null,
      idCategoriaNuevo: null,
      palabraClaveBusqueda: '',
      catalogoTratamientos: [],
      caracteristicasByCategoria: [],
      tratamientoSeleccionado: null,
      listaAdicional: [],
      indexTratamientoSeleccionado: null,
 /*     opciones: [
        {nombre: "Tratamiento"},
        {nombre: "Asignar tratamiento"}
      ],*/
      opcionTabSeleccionada: 0,
      listaExtension: [],
      listaValor: [],
      listaEspecialidades: [],
      listaCompletaTratamientos: [],
      listaPerfiles: [],
      listaCaracteristicas: [],
      resultadosBusquedaFiltro: [],
      loaderGuardar: false,
    };
  },
  validations: {},
  computed: {
    tieneFiltro() {
      return this.palabraClaveBusqueda !== ''
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCategorias();
    this.obtenerEspecialidades();
   // this.obtenerPerfiles();   No se meten perfiles por ahora

  },
  mounted () {
      this.$root.$on('enviarTratamiento', async(data) => {
        this.seleccionarTratamiento(data)
      })
    },
  watch: {},
  methods: {
    seleccionarTratamiento(tratamiento, index){
      this.tratamientoSeleccionado = tratamiento;
      if (this.tratamientoSeleccionado.subTratamientos != null){
        this.listaAdicional = this.tratamientoSeleccionado.subTratamientos;
        this.listaAdicional.forEach(la => this.agregarMetadatos(la));
      }
      this.agregarMetadatos(this.tratamientoSeleccionado);
      this.indexTratamientoSeleccionado = index;

    },
    agregarMetadatos(tratamiento) {
      if (tratamiento.metadatos === null) {
        tratamiento.metadatos = [];
        this.caracteristicasByCategoria.forEach(c => {
          tratamiento.metadatos.push({
            idCaracteristica: c.idCaracteristica,
            descripcionCaracteristica: c.descripcionCaracteristica,
            caracteristicaIngresada: c.caracteristicaIngresada
          })
        })
      }
    },
    obtenerTratamientosNuevos(){

      this.listaCompletaTratamientos = [];
      this.$http.get(this.$api + "tratamientos/obtenerTratamientos")
          .then((response) => {
            if (response.status === 200) {
              this.listaCompletaTratamientos = response.data.data;
              this.listaCompletaTratamientos.forEach(d => {
                this.convertirMetadatosJSON(d)
              })

              this.obtenerExtensiones();
              this.obtenerValor();
              this.changeTab(0, this.tabs[0])
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    convertirMetadatosJSON(tratamiento) {
      if (tratamiento.metadatos !== null && tratamiento.metadatos.trim() !== '') {
        tratamiento.metadatos = JSON.parse(tratamiento.metadatos);

        if (tratamiento.subTratamientos != null && tratamiento.subTratamientos.length > 0) {
          tratamiento.subTratamientos.forEach(sub => {
            this.convertirMetadatosJSON(sub)
          })
        }
      }
    },
    buscarTodoTratamientos(index){
      this.opcionTabSeleccionada = index;
    },
    iniciarLista(trt){
      this.listaAdicional = []
      const nuevaIniciarLista = {
        idTratamientoPadre: trt.idTratamientoNuevo,
        nombre: null,
        descripcion: null,
        atributo1: null,
        idCategoriaNuevo: this.idCategoriaNuevo,
        sku: trt.sku,
        metadatos: null,
      }
      this.agregarMetadatos(nuevaIniciarLista);
      this.listaAdicional.push(nuevaIniciarLista)
    },
    agregarSubTratamiento(trt) {
      const nuevoSubTratamiento = {
        idTratamientoPadre: trt.idTratamientoNuevo,
        nombre: null,
        descripcion: null,
        atributo1: null,
        idCategoriaNuevo: this.idCategoriaNuevo,
        sku: parseFloat(this.tratamientoSeleccionado.sku) + 0.1,
        metadatos: null,
      }

      this.agregarMetadatos(nuevoSubTratamiento);

      this.listaAdicional.push(nuevoSubTratamiento)
    },
    cancelar() {
      this.convertirMetadatosJSON(this.tratamientoSeleccionado)
    },
    async guardarTratamiento(){

      this.tratamientoSeleccionado.subTratamientos = this.listaAdicional;

      await this.convertirMetadatosString(this.tratamientoSeleccionado);
      if (this.tratamientoSeleccionado.subTratamientos.length === 0 ) {
        this.$swal.fire({
          title: 'Nivel 1 sin subcatálogo',
          text: 'El tratamiento "' + this.tratamientoSeleccionado.nombre +'" se creará sin un subcatálogo, ¿desea continuar?',
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, continuar",
          cancelButtonText: "No, cancelar",
          customClass: 
            {
              confirmButton: 'rounded-pill',
              cancelButton: 'rounded-pill'
            },
        }).then((aceptar) => {
          if (aceptar.isConfirmed) {
            this.metodoGuardar(this.tratamientoSeleccionado)
          } else {
            this.cancelar();
          }
        })
      } else {
          this.$swal.fire({
            title: '¿Esta seguro?',
            text: 'El tratamiento "' + this.tratamientoSeleccionado.nombre +'" se creará, ¿desea continuar?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, continuar",
            cancelButtonText: "No, cancelar",
            customClass:
                {
                  confirmButton: 'rounded-pill',
                  cancelButton: 'rounded-pill'
                },
          }).then((aceptar) => {
            if (aceptar.isConfirmed) {
              this.metodoGuardar(this.tratamientoSeleccionado)
            } else {
              this.cancelar();
            }
          })
      }
    },
    metodoGuardar(tratamientoGuardar){

      this.loaderGuardar= true;
      this.$http.post(this.$api + "tratamientos/guardarTratamientoNuevo", tratamientoGuardar)
          .then((response) => {
            if (response.data.data) {
              this.loaderGuardar = false;
              this.$swal.fire({
                title: 'Creación de nivel',
                text: response.data.message,
                icon: "success",
                showConfirmButton: true,
                showCancelButton: false,
                cancelButtonText: "Cerrar",
                confirmButtonText: "Aceptar",
                customClass: {
                  confirmButton: 'rounded-pill'
                },
                preConfirm: () => {
                  this.obtenerCategorias()
                }
              })
            }else {
              this.loaderGuardar = false;
              this.$swal.fire({
                title: 'Oops...',
                text: response.data.message,
                icon: "warning",
                showConfirmButton: true,
                showCancelButton: false,
                cancelButtonText: "Cerrar",
                customClass: {
                  cancelButton: 'rounded-pill'
                },
                preConfirm: () => {
                  this.loaderGuardar = false;
                  this.obtenerCategorias()
                }
              })
            }
          }).catch((error) => {
            console.error(error);
            this.loaderGuardar= false;

            var message = error.response.data.message
                ? error.response.data.message
                : "Error al actualizar el tratamiento";

                this.$swal.fire({
                  icon: "error",
                  title: "Atención",
                  text: message,
                  showCancelButton: false,
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  cancelButtonText: "Aceptar",
                  /*confirmButtonText: "Ver planes",*/
                  confirmButtonColor: "#0e6ba9",
                }).then((ok)=> {
                  if (ok.isConfirmed){
                    this.obtenerCategorias()
                  }
                })



          }).finally(this.obtenerCategorias());
    },

    convertirMetadatosString(tratamiento) {
      let metadatos;
      let caracteristicas = [];

      if (tratamiento.metadatos !== null &&
          tratamiento.metadatos.length > 0 &&
          (tratamiento.metadatos.length === this.caracteristicasByCategoria.length)) {

        metadatos = JSON.stringify(tratamiento.metadatos);

      } else if (tratamiento.metadatos !== null &&
          tratamiento.metadatos > 0) {
        this.caracteristicasByCategoria.forEach(c => {
          let caracteristica = tratamiento.metadatos.find(carac => carac.idCaracteristica === c.idCaracteristica)

          caracteristicas.push({
            idCaracteristica: c.idCaracteristica,
            descripcionCaracteristica: c.descripcionCaracteristica,
            caracteristicaIngresada: caracteristica.caracteristicaIngresada
          })
        })
        metadatos = JSON.stringify(caracteristicas);
      }

      tratamiento.metadatos = metadatos;

      if (tratamiento.subTratamientos != null && tratamiento.subTratamientos.length > 0) {
        tratamiento.subTratamientos.forEach(sub => {
          this.convertirMetadatosString(sub)
        })
      }
    },
    agregarNuevoTratamiento(){
      this.listaAdicional = [];
      this.loaderGuardar = false;
      const nuevoTratamiento = {
        idTratamientoNuevo: null,
        nombre: null,
        descripcion: "",
        idExtensionTratamiento: null,
        idValorTratamiento: null,
        idEspecialidad: null,
        metadatos: null,
        subTratamientos: null,
        idCategoriaNuevo: this.idCategoriaNuevo,
      };

      this.agregarMetadatos(nuevoTratamiento);

      this.catalogoTratamientos.unshift(nuevoTratamiento);
      this.tratamientoSeleccionado = this.catalogoTratamientos[0];
      this.indexTratamientoSeleccionado = 0;
    },

    obtenerEspecialidades(){
      this.$http.get(this.$api + "catalogos/obtenerEspecialidadesOrigen")
          .then((response) => {
          if (response.status === 200) {
            this.listaEspecialidades = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    obtenerCategorias(){

      this.$http.post(this.$api + "categoriaNuevo/obtenerNuevasCategorias")
          .then((response) => {
            if (response.status === 200) {
              this.tabs = response.data.data;
              this.obtenerCaracteristicasCategorias();

            }
          })
          .catch((error) => {
            console.error(error);
          });
    },

    obtenerCaracteristicasCategorias(){
      this.$http.post(this.$api + "catalogo/caracteristicas/categoria/obtenerCaracteristicas/tratamientos")
          .then((response) => {
            if (response.status === 200) {
              this.listaCaracteristicas = response.data.data;
              this.obtenerTratamientosNuevos();
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },


    obtenerExtensiones(){
      this.$http.get(this.$api + "catalogos/obtenerExtensionTratamientoActivos")
          .then((response) => {
            if (response.status === 200) {
              this.listaExtension = response.data.data
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },


    obtenerValor(){
      this.$http.get(this.$api + "catalogos/obtenerValorTratamientoActivos")
          .then((response) => {
            if (response.status === 200) {
              this.listaValor = response.data.data
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },

    obtenerPerfiles(){
      this.$http.post(this.$api + "catalogos/perfil/listarPerfiles")
          .then((response) => {
            if (response.status === 200) {
              this.listaPerfiles = response.data.data
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },





    buscarTratamiento() {
      this.resultadosBusquedaFiltro = this.buscarHijos(this.catalogoTratamientos)
    },
    buscarHijos(tratamiento) {
      return tratamiento.filter(tx => {
        if (tx.nombre.toLowerCase().includes(this.palabraClaveBusqueda.toLowerCase().trim())){
          return true;
        } else if (tx.subTratamientos !== null && tx.subTratamientos.length > 0) {
          let resultado = this.buscarHijos(tx.subTratamientos);
          return resultado !== null && resultado.length > 0;
        }
      })
    },
    changeTab(index, tab) {
      this.activeTab = index;
      this.nombreTabSeleccionado = tab.descripcion;
      this.idCategoriaNuevo = tab.idCategoriaNuevo;
      this.tratamientoSeleccionado = null;
      this.catalogoTratamientos = [];
      this.listaCompletaTratamientos.forEach(t => {
        if (t.idCategoriaNuevo === tab.idCategoriaNuevo){
          this.catalogoTratamientos.push(t)
        }
      })
      this.resultadosBusquedaFiltro = this.catalogoTratamientos;
      if (this.tieneFiltro) {
        this.buscarTratamiento();
      }
      this.caracteristicasByCategoria = [];
      this.listaCaracteristicas.forEach(t => {
        if (t.idCategoria === tab.idCategoriaNuevo){
          this.caracteristicasByCategoria.push(t)
        }
      })
    },

    eliminarTratamiento(tratamiento, estatus) {

      if (estatus === false) {

        const params = {
          idTratamientoNuevo: tratamiento.idTratamientoNuevo,
          idTratamiento: tratamiento.idTratamiento,
          registroBool: true,
          enviarNotificacion: false,
          enPromocion: null,
        }

        this.$swal.fire({
          html: '<strong><span>¿Quieres desactivar el tratamiento únicamente para nuevos diagnósticos o también para tratamientos programados?</span></strong> <br>' +
              ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> Si escoges tratamientos programados, ' +
              'este tratamiento ya no se podrá ejecutar en ninguna clínica de dentalia, aunque esté programado.</h5> <br> ',
          icon: "warning",
          showCancelButton: true,
          showDenyButton: true,
          denyButtonText: "Don't save",
          confirmButtonText: "Nuevos diagnósticos",
          cancelButtonText: "Todos",
          confirmButtonColor: '#1c86dc',
          cancelButtonColor: '#eab059',
          /*showDenyButton: true,
          denyButtonText: `Don't save`,*/
          showLoaderOnConfirm: true,
        }).then((result) => {
          console.log(result)
          if (result.isConfirmed) {
            /*** registroActivo = false, promo = true **  */
            params.enPromocion = true;
            params.registroBool = false;
            this.loadingFull = true;
            this.cambiarEstatusTratamiento(params)
          } else if(result.dismiss === "cancel" ) {
            /*** registroActivo = false, promo = false **  */
            params.enPromocion = false;
            params.registroBool = false;
            this.loadingFull = true;
            this.cambiarEstatusTratamiento(params)
          }
        })
      } else {
        var title = "";
        title = "¿Estás seguro de activar el tratamiento?";

        this.$swal.fire({
          text: title,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.loadingFull = true;
            const params = {
              idTratamientoNuevo: tratamiento.idTratamientoNuevo,
              idTratamiento: tratamiento.idTratamiento,
              registroBool: estatus,
              enPromocion: false,
              enviarNotificacion: false,
            }
            this.cambiarEstatusTratamiento(params)
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      }

    },
    cambiarEstatusTratamiento(params){
      this.$http
          .put(this.$api + "tratamientos/cambiarEstatusTratamiento", params)
          .then((response) => {
            if (response.status === 200) {
              this.loadingFull = false;
              this.$swal({
                icon: "success",
                title: "Se actualizó correctamente",
                showConfirmButton: false,
                timer: 1500,
              });
              var message = response.data.message
                  ? response.data.message
                  : "Se actualizó correctamente el registro";
              miniToastr.success(message);
            }
            this.obtenerCategorias();
          }).catch((error) => {
            this.loadingFull = false;
            var message = error.response.data.message
                ? error.response.data.message
                : "Error al actualizar el tratamiento";

            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: message,
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: false,
              cancelButtonText: "Aceptar",
              /*confirmButtonText: "Ver planes",*/
              confirmButtonColor: "#0e6ba9",
            })
          })
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 46 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },

  }
};
</script>

<style scoped>
p {
  color: #6f6f6f;
}
.titulos-peques {
 color:  #17A2B8;
  font-weight: bold;
  font-size: 14px;
}

.btn-primary {
        color: #FFF;
        background-color: #4899CF;
    }

    .btn-primary:hover {
        color: #4899CF;
        background-color: #FFF;
    }

.tabTxtSeleccionado{
  font-size: .9vw;
  color: #17A2B8;
}

.tabTxt{
  font-size: .9vw;
  color: #717171;
}



  .tabOpciones.seleccionado{
    border-style: solid;
    border-width: 1px;
    border-color: #90D3DD;
    border-radius: 10px;
    color: #17a2b8;
  
  }

  .tabOpciones:hover{
    font-weight: 600;
  }
.tratamiento{
  background-color: #F9F9F9;
}

.tratamiento-seleccionado{
  background-color: #CEEBF0;
}

.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #c2e7ff;
    background: #ffffff;
    margin-top: 20px;
   /*  margin-right: 3%;*/
    margin-left: 4%;
    padding-right: 4%;
    padding-left: 1%;
    border-radius: 20px;
    text-align: left;
    align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
}

.tabs {
  position: relative;
  margin: 1em 0;
  width: 40%;
}

.tabs .tabs-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;
  padding: .4em 2em .4em 2em;
  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover { /* al sobre poner el mouse */
  color: #369bda;
}

.tabs .tabs-nav ul li.active { /* borde inferior */
  border-bottom: 3px solid #0069A9;
}

.tabs .tabs-nav ul li.active a {
  color: #0069A9;
  font-weight: 600;
}

.tabs .tabs-content {
  width: 100%;
}

</style>
